import {format} from 'date-fns';
import {MatchSimple} from 'utils/types';
import {MatchesAction, MatchesState} from './types';
import {
  LIVE_MATCH_SCORE_GET_RESPONSE,
  SPORTEVENTS_BY_COMPETITION_MONTH_GET_INVALIDATE,
  SPORTEVENTS_BY_COMPETITION_MONTH_GET_REQUEST,
  SPORTEVENTS_BY_COMPETITION_MONTH_GET_RESPONSE,
  SPORTEVENTS_BY_DATE_GET_INVALIDATE,
  SPORTEVENTS_BY_DATE_GET_REQUEST,
  SPORTEVENTS_BY_DATE_GET_RESPONSE,
  SPORTEVENTS_BY_SPORT_MONTH_GET_INVALIDATE,
  SPORTEVENTS_BY_SPORT_MONTH_GET_REQUEST,
  SPORTEVENTS_BY_SPORT_MONTH_GET_RESPONSE,
} from '../actionTypes';
import updateLiveMatches from './utils/updateLiveMatches';


const initialState: MatchesState = {
  isFetching: false,
  didInvalidate: false,
};

const groupMatchesByDate = (matches: MatchSimple[]): Record<string, MatchSimple[]> => {
  const matchesByDate: Record<string, MatchSimple[]> = {};
  matches.forEach((m) => {
    const matchDateAsString = format(m.date, 'yyyy-MM-dd');
    if (typeof matchesByDate[matchDateAsString] === 'undefined') {
      matchesByDate[matchDateAsString] = [m];
    } else {
      matchesByDate[matchDateAsString].push(m);
    }
  });
  return matchesByDate;
};

/**
 * Derives the 'matches' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const matchesReducer = (state: MatchesState = initialState, action: MatchesAction): MatchesState => {
  switch (action.type) {
    case SPORTEVENTS_BY_COMPETITION_MONTH_GET_REQUEST:
    case SPORTEVENTS_BY_SPORT_MONTH_GET_REQUEST:
    case SPORTEVENTS_BY_DATE_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case SPORTEVENTS_BY_DATE_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: {
          ...state.data,
          [action.payload.date]: action.payload.matches,
        },
      });
    case SPORTEVENTS_BY_COMPETITION_MONTH_GET_RESPONSE:
    case SPORTEVENTS_BY_SPORT_MONTH_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: {
          ...state.data,
          ...groupMatchesByDate(action.payload.matches),
        },
      });
    case SPORTEVENTS_BY_COMPETITION_MONTH_GET_INVALIDATE:
    case SPORTEVENTS_BY_SPORT_MONTH_GET_INVALIDATE:
    case SPORTEVENTS_BY_DATE_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case LIVE_MATCH_SCORE_GET_RESPONSE: {
      const date = action.payload.matchDate;
      const nextData = state.data ? state.data[action.payload.matchDate] : [] as MatchSimple[];

      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: {
          ...state.data,
          [date]: updateLiveMatches(nextData, action.payload.liveData),
        },
      });
    }
    default:
      return state;
  }
};

export default matchesReducer;
